import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/layout/main/base.component';
import { AppConstants } from 'src/app/app.constants';
import { EmailStatus, SendMigrationLinkBindingModel } from 'src/app/api/models/web-booking.models';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit {

  email = '';

  ngOnInit() {
    this.app.pageTitle = 'Reset your password';
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();
      this.scrollTo();
    });
    this.start();
  }

  backToLogin() {
    this.app.router.navigate([AppConstants.RouteLogin]);
  }

  checkEmail() {
    this.app.spinner.show();
    var model = { email: this.email };
    this.app.webBookingService.CheckEmailStatus(model)
      .subscribe(
        data => {
          if (data.status == EmailStatus.Blocked) {
            this.app.spinner.hide();
            this.showErrorMessage('Email address is suspended.');
          }
          else if (data.status == EmailStatus.EmailVerified) {
            this.submit();
          }
          else if (data.status == EmailStatus.ForCustomerMigration) {
            this.sendMigrationLink();
          }
          else if (data.status == EmailStatus.WaitingForEmailVerification) {
            this.submit();
          }
          else if (data.status == EmailStatus.NotYetRegistered) {
            this.app.spinner.hide();
            this.showErrorMessage('Email address is not yet registered.');
          }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  submit() {
    this.app.spinner.show();
    var model = { email: this.email, resetPageUrl: this.app.configService.config.appUrl + 'reset-password/' };
    this.app.webBookingService.SendPasswordResetKeyLinkToEmail(model)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, this.email);
          this.showSuccessMessage('Reset password code has been sent to your email address.');
          this.app.router.navigate([AppConstants.RouteResetPassword]);
        },
        error => {
          this.showErrorMessage(error);
          this.app.spinner.hide();
        });
  }

  sendMigrationLink() {
    var m = new SendMigrationLinkBindingModel();
    m.email = this.email;
    m.branchId = this.app.branch.branchId;
    this.app.webBookingService.SendMigrationLink(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, this.email);
          this.showInfoMessage('Please check your email to active your online account');
          this.app.router.navigate([AppConstants.RouteMigrateCustomer]);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

}
